module.exports = __webpack_public_path__ + "img/q5.a672de81.jpg";